import { motion } from "framer-motion";
import ScrollAnimation from "../../../hooks/ScrollAnimation";
import { contentConfig } from "../../../config/contentConfig";

const ProfileContent = ({ activeTab, userData, setUserData, role }) => {
  const ContentComponent = contentConfig[role]?.[activeTab];

  const fallback = (
    <div className="text-center py-10 text-gray-500">
      الصفحة غير متوفرة
    </div>
  );

  return (
    <ScrollAnimation className="flex-1" direction="right" delay={0.2}>
      <motion.div
        className="flex-1 min-w-0"
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.3, duration: 0.6 }}
      >
        <div className="bg-white rounded-xl shadow-lg p-6 lg:p-8 min-h-[600px]">
          {ContentComponent ? (
            <ContentComponent userData={userData} setUserData={setUserData} />
          ) : (
            fallback
          )}
        </div>
      </motion.div>
    </ScrollAnimation>
  );
};

export default ProfileContent;